<div [ngClass]="{ 'display-full-height': fullHeight && (loading || error) }">
  <div *ngIf="loading && compact">
    <div
      class="compact-loader"
      [ngStyle]="{
        width: compactSize + 'px',
        height: compactSize + 'px',
      }"></div>
  </div>
  <div
    class="loader-container"
    *ngIf="loading && !compact"
    [ngStyle]="{ opacity: loading ? 1 : 0 }">
    <div>
      <div
        [ngClass]="tableColumnLoader ? 'table-column-loader' : 'loader'"></div>
      <label>{{ reason }}</label>
    </div>
  </div>
  <div class="col" *ngIf="!loading && error">
    <h5>An Error has Occurred</h5>
    <label>Message: "{{ error }}"</label>
  </div>
  <div
    *ngIf="!loading && !error"
    class="loader-content"
    [ngStyle]="{
      opacity: getOpacity(),
    }">
    <ng-content></ng-content>
  </div>
</div>
